module.exports = __webpack_public_path__ + "static/media/javascript.0f420112.png";